<template>
    <!-- FIXME: isHideContent：垃圾代码适配官网需求 -->
    <!-- FIXME: isHideContent：垃圾代码适配官网需求 -->
    <!-- FIXME: isHideContent：垃圾代码适配官网需求 -->
    <div :class="{ 'app-container': true, 'app-container--content-less': isHideContent }">
        <div class="nav-menu" :class="{'featured-data':currentNav ==='FeaturedData'}">
            <div
                v-for="(item) in navList"
                :key="item"
                :class="{'active':item === currentNav,}"
                class="nav-menu-item"
                @click="handleChangeNav(item)"
            >
                {{ $t(`nav.${item}`) }}
            </div>
        </div>
        <components :is="currentView" />
    </div>
</template>

<script>
import 'library-@/assets/styles/reset.scss';
import DataCoverage from './children/data-coverage/DataCoverage';
import FeaturedData from './children/featured-data/FeaturedData';
import qs from 'qs';

export default {
    components: {
        DataCoverage,
        FeaturedData,
    },
    data() {
        // 如果带参数header 0 隐藏头部
        const { header = 1, content = 1 } = qs.parse(window.location.search.substring(1));
        return {
            navList: ['Update', 'FeaturedData'],
            currentNav: '',
            isHideHeader: parseInt(header) === 0,
            isHideContent: parseInt(content) === 0,
        };
    },
    computed: {
        currentView() {
            return this.currentNav === 'Update' ? DataCoverage : FeaturedData;
        }
    },
    methods: {
        handleChangeNav(val) {
            if (this.currentNav === val) {
                return;
            }
            this.currentNav = val;
        },
    },
    created() {
        this.currentNav = this.navList[0];
    },
    mounted () {
        if (this.isHideHeader) {
            const headerEl = document.getElementById('header-wrapper');
            if (headerEl) {
                headerEl.style.display = 'none';
            }
            const appEl = document.querySelector('.app-container');
            if (appEl) {
                appEl.style.top = 0;
            }
        }
    }
};
</script>

<style lang="scss">
body{
    &.js-focus-visible{
        overflow: hidden;
    }
}
.app-container {
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;

    .patsnap-biz-icon {
        font-size: 24px;
        fill: $text-hint;
        margin-bottom: 0;

        &[icon="SolidInfo"] {
            margin-left: 2px;
            cursor: pointer;
            fill: #B3BAC5;
        }
    }

    .nav-menu {
        position: absolute;
        top: 14px;
        right: 30px;
        display: flex;
        justify-content: end;
        z-index: 21;
        &.featured-data {
            position: sticky;
            padding-top: 14px;
            top: 0;
            right: 0;
            padding-right: 30px;
            background: $bg-white;
        }

        .nav-menu-item {
            position: relative;
            color: $text-secondary;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            padding: 10px 0;
            cursor: pointer;
            box-sizing: content-box;

            &:first-child {
                margin-right: 24px;
            }

            &.active {
                color: $green-primary;

                &:after {
                    content: "";
                    border-bottom: 2px solid $green-primary;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                }
            }
        }
    }

    //FIXME: 垃圾代码适配官网需求
    //FIXME: 垃圾代码适配官网需求
    //FIXME: 垃圾代码适配官网需求
    &--content-less {
        .global-patent-databases-wrapper,
        .legal-databases-wrapper,
        .literature-database-wrapper,
        .data-coverage-map-total-patents-more {
            display: none !important;
        }
    }
}

</style>
